import styled from '@emotion/styled';

export const TimeValue = styled.span`
    margin: 0 1px;
    font-size: inherit;
    font-family: 'open_sans_semi', sans-serif;

`;
